<template>
	<!-- 版权管理-->
	<div style="background-color: #F5F5F5;overflow: hidden;">
		<div class="copyright comBox ">

			<div>
				<div style="height: 0.08rem;"></div>
				<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
					<el-tab-pane :label="item.label" :name="item.name" v-for="item in activeList" :key="item">
						<div class="newTrialMaterial_box">
							<div style="display: flex;justify-content: flex-start;">
								<el-input style="width:300px" v-model="searchValue" placeholder="输入作品名称、编号进行搜索" />
								<div class="searchBtn">搜索</div>
							</div>
						</div>
						<el-table ref="multipleTableRef" :data="tableData" style="width: 100%" height="650">

							<el-table-column property="id" label="作品编号" align="center">
							</el-table-column>
							<el-table-column property="name" label="作品名称 " align="center">
							</el-table-column>
							<el-table-column property="type" label="存证渠道" align="center">
							</el-table-column>
							<el-table-column property="time" label="提交时间" align="center">
							</el-table-column>
							<el-table-column property="name" label="存证状态" align="center">
								<template #default="scope">
									<span v-if="scope.$index != 1" style="color: #4BC185;background: #4BC18520;padding: 0.02rem 0.04rem;box-sizing: border-box;
border-radius: 0.04rem;">
										已存证
									</span>
									<span v-else
										style="color: #F53F3F;background: #F53F3F20;padding: 0.02rem 0.04rem;box-sizing: border-box;border-radius: 0.04rem;">
										存证失败
									</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="190" align="center">
								<template #default="scope">

									<div style="display: flex;" v-if="scope.$index == 1">
										<div style="color: #3FA4ED;margin-left: 0.1rem;line-height: 0.43rem;">重新存证</div>
									</div>
									<div style="display: flex;" v-else>
										<div style="color: #3FA4ED;margin-left: 0.1rem;line-height: 0.43rem;">下载证书</div>

										<div style="color: #3FA4ED;margin-left: 0.1rem;line-height: 0.43rem;">查看作品</div>
									</div>

								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>


			</div>

		</div>
		<div style="display: flex;justify-content: center;margin-bottom:0.23rem;">
			<el-pagination background layout="prev, pager, next" :total="1000" />
		</div>


	</div>

</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import type { TabsPaneContext } from 'element-plus'
	import { ElTable } from 'element-plus'

	const activeName = ref('first');

	const searchValue = ref('');

	const activeList = ref([
		{
			label: '版权存证',
			name: 'first',
			satus: 1,
		}, {
			label: '著作权登记',
			name: 'second',
			satus: 2,
		}
	])
	const handleClick = (tab : TabsPaneContext, event : Event) => {
		console.log(tab, event)
	}

	// 表格
	const allCheckbox = ref(false)

	interface User {
		date : string
		name : string
		address : string
		katype : string
		pirce : string,
		number : number,
	}

	const multipleTableRef = ref<InstanceType<typeof ElTable>>()
	const multipleSelection = ref<User[]>([])
	const toggleSelection = (rows ?: User[]) => {
		if (rows) {
			rows.forEach((row) => {
				multipleTableRef.value!.toggleRowSelection(row, undefined)
			})
		} else {
			multipleTableRef.value!.clearSelection()
		}
	}
	const handleSelectionChange = (val : User[]) => {
		multipleSelection.value = val
	}
	var data = [];  // 创建一个空数组

	for (var i = 0; i < 10; i++) {
		data.push({
			id: '45648941615641',
			name: '手绘青海风景动态大屏',
			pirce: '￥500.00',
			type: '联合信任时间戳服务中心',
			time: '2023-06-08 15:14',
			katype: '未开票',
			faid: '/',
			number: 34
		});  // 将相同的数据添加到数组中
	}
	const tableData : User[] = data;
</script>

<style scoped>
	@import url(/src/assets/css/com.css);

	.searchBtn {
		width: 1rem;
		height: 0.45rem;
		line-height: 0.45rem;
		text-align: center;
		background: #FF6000;
		border-radius: 0 0.1rem 0.1rem 0;
		opacity: 1;
		color: #fff;
	}

	.copyright {
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		opacity: 1;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		flex-direction: column;
		margin: 0.3rem auto 0.3rem;
		box-sizing: border-box;
	}

	.newTrialMaterial_box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 0.2rem 0rem;
		box-sizing: border-box;
		vertical-align: middle;
		background-color: rgb(245, 245, 245)
	}

	.topBtn {
		font-size: 0.14rem;
		padding: 0.08rem 0.16rem;
		text-align: center;
		color: #333333;
		background: #FFFFFF;
		border-radius: 0.2rem;
		opacity: 1;
		border: 0.01rem solid #E5E6EB;
		margin-left: 0.2rem;
	}

	.table_img {
		background-color: #3FA4ED;
		width: 1rem;
		height: 0.8rem;
		background: #D9D9D9;
		border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		opacity: 1;
		margin-right: 0.1rem;
	}

	.table_information {
		width: calc(100% - 1rem - 0.1rem);
		height: 0.8rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	/deep/.el-tabs__nav-wrap::after {
		display: none;
	}

	/deep/ .el-table th.el-table__cell.is-leaf {
		/* background: #E3E6EC !important; */
	}

	/deep/th .cell .el-checkbox__input {
		display: none;
	}

	/deep/.el-checkbox.el-checkbox--large {
		height: 0.2rem !important;
	}

	/deep/.is-active {
		color: #FF6000
	}

	/deep/.el-tabs__active-bar {
		display: none;
	}

	/deep/.el-tabs__nav {
		padding: 0 0.16rem;
	}

	/deep/.el-tabs__item:hover {
		color: #ff6000 !important;
	}


	/deep/.el-dialog.is-align-center {
		border-radius: 20px !important;
	}

	/deep/.rate .el-icon,
	/deep/.rate .el-icon svg {
		height: 2em !important;
		width: 2em !important
	}

	/deep/.el-tabs__active-bar {
		display: none !important;
	}

	/deep/.el-tabs__item:hover {
		color: #FF6000;
	}

	/deep/.el-tabs__item.is-active {
		color: #FF6000;
	}

	/deep/.el-tabs__nav-scroll {
		padding-left: 0.12rem;
	}
</style>